
export const getCookie = (name: string) => {
  const regex = new RegExp(`(^|; )${name}=([^;]+)`)
  return document.cookie.match(regex)?.[2];
};

const getCookieDomain = () => {
  const hostname = window.location.hostname;
  if (hostname === 'feedbackjourney.com' || hostname.endsWith('.feedbackjourney.com')) {
    return 'feedbackjourney.com';
  }

  return undefined;
};

export const setCookie = (name: string, value: string | null, path = '/', expires: boolean | Date = false) => {
  let expDate;
  if (!expires) {
    const expDateObj = new Date();
    expDateObj.setFullYear(expDateObj.getFullYear() + 1);
    expDate = expDateObj.toUTCString();
  } else if (typeof expires === 'string') {
    expDate = expires;
  } else {
    expDate = (expires as Date).toUTCString();
  }
  const domain = getCookieDomain();
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  const domainAttr = domain ? `; domain=${domain}` : '';
  document.cookie = `${name}=${value}; expires=${expDate}; path=${path}${domainAttr}; samesite=lax${secure}`;
}
